<template>
    <div class="container">
        <div id="phone" v-show="setPhonePage">
            <div class="header">
                <div class="title">Welcome</div>
                <div class="subtitle">註冊或繼續使用跑跑腿</div>
            </div>
            <div class="content">
                <div>
                    <input type="tel" v-model="phone" class="phone" placeholder="輸入手機號碼 0987654321">
                    <div class="err-msg">
                        <span v-show="errMsg">{{ errMsg }}</span>
                    </div>
                </div>
                <div class="buttons">
                    <div class="button" @click="sendPhone" :class="phoneBtn">
                        取得驗證碼
                    </div>
                </div>
            </div>
            <div class="footer">
                <div class="terms-of-use">
                    登入/註冊 即同意
                    <br/>
                    <a target="_blank" href="https://paopaotui.com.tw/userlegal.html">使用者條款</a> / <a target="_blank" href="https://paopaotui.com.tw/privacy.html">隱私權條款</a>
                </div>
            </div>
        </div>
        <div id="verify" v-show="setVerifyPage">
            <div class="help">
                <a target="_blank" href="https://line.me/R/ti/p/%40hjc7084c">收不到驗證碼嗎？</a>
            </div>
            <div class="field">
                <input type="tel" v-model="phone" class="phone" placeholder="輸入手機號碼 0987654321">
            </div>
            <div class="field">
                <input type="text" v-model="code" class="code" placeholder="輸入驗證碼">
                <div class="err-msg">
                    <span v-show="errMsg">{{ errMsg }}</span>
                </div>
            </div>
            <div class="buttons">
                <div class="button" @click="sendCode" :class="verifyBtn">
                    確定
                </div>
                <div class="resend" @click="resendCode">
                    {{ seconds || '' }} {{ resendMessage }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'
    import Swal from "sweetalert2";

    export default {
        name: 'Login',
        data() {
            return {
                phone: '',
                code: '',
                page: 'phone',
                errMsg: '',
                seconds: 30,
                resendMessage: '秒後可重新寄送驗證碼',
                countDown: null,
                ic: null,
            }
        },
        computed: {
            setPhonePage() {
               return this.page === 'phone';
            },
            setVerifyPage() {
                return this.page === 'verify'
            },
            phoneBtn() {
                return {
                    active: this.phone.match(/^09\d{8}$/),
                }
            },
            verifyBtn() {
                return {
                    active: this.code.length === 6,
                }
            },
            ...mapGetters(['lineBotId']),
        },
        methods: {
            sendPhone() {
                if (! this.checkPhone(this.phone)) {
                    return ;
                }

                this.login(this.phone).then(() => {
                    this.page = 'verify';
                    this.initCountDown();
                }).catch(() => {
                    this.errMsg = '錯誤的手機號碼';
                });
            },
            checkPhone(value) {
                if (value.match(/^09\d{8}$/)) {
                    this.errMsg = '';
                    return true;
                }

                this.errMsg = '錯誤的手機號碼';
                return false;
            },
            sendCode() {
                if (! this.checkCode(this.code)) {
                    return;
                }

                if (! this.checkPhone(this.phone)) {
                    return;
                }

                let payload = {
                    'phone': this.phone,
                    'code': this.code,
                };

                if (localStorage.getItem('registration_token')) {
                    payload.registration_token = localStorage.getItem('registration_token');
                }

                this.verify(payload).then(res => this.logged(res)).catch(err => {
                    this.errMsg = err.response.data.message;
                });
            },
            logged(res) {
                if (this.lineBotId) {
                    this.updateMe({
                        line_bot_id: this.lineBotId,
                    })
                }

                if (res.data.user.name) {
                    if (this.ic) {
                        Swal.fire({
                            title: '邀請碼失效',
                            text: '已註冊過的帳號無法使用邀請碼',
                        });
                    }
                    this.$router.replace({name: 'home'});
                    return;
                }

                this.$router.replace({name: 'register', query: {ic: this.ic}});
            },
            checkCode(value) {
                if (value.match(/^[a-z A-Z 0-9]{6}$/)) {
                    this.errMsg = '';
                    return true;
                }

                this.errMsg = '驗證碼錯誤';
                return false;
            },
            resendCode() {
                if (this.seconds) {
                    return;
                }

                this.sendPhone();
                this.initCountDown();
            },
            initCountDown() {
                this.seconds = 30;
                this.resendMessage = '秒後可重新寄送驗證碼';
                this.countDown = window.setInterval(() => {
                    this.seconds -= 1;
                    if (this.seconds <= 0) {
                        this.resendMessage = '重新寄送驗證碼';
                        this.seconds = 0;
                        window.clearInterval(this.countDown)
                    }
                }, 1000);
            },
            ...mapActions(['login', 'verify', 'loginByLine', 'updateMe'])
        },
        created() {
            if (this.lineBotId) {
                this.loginByLine(this.lineBotId).then(res => this.logged(res));
            }

            let token = liff.getDecodedIDToken();
            if (token) {
                this.phone = token.phone_number.replace('+886', '0');
            }


            this.ic = this.$route.query.ic;
        },
        beforeDestroy() {
            if (this.countDown) {
                window.clearInterval(this.countDown);
            }
        }
    };
</script>

<style scoped>
    .container {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .title {
        height: 31px;
        width: 100%;
        color: #000000;
        font-size: 26px;
        font-weight: 900;
        letter-spacing: 2.01px;
        line-height: 31px;
        text-align: center;
        margin-top: 130px;
    }

    .subtitle {
        height: 25px;
        width: 100%;
        color: #000000;
        font-size: 18px;
        letter-spacing: 0.81px;
        line-height: 25px;
        text-align: center;
        margin-top: 6px;
    }

    .phone, .code {
        width: 240px;
        border-color: transparent;
        border-bottom-color: #D8D8D8;
        margin-top: 55px;
        padding: 10px;
    }

    .buttons {
        width: 100%;
    }

    #phone > .content > .buttons {
        margin-top: 22px;
    }

    #verify > .buttons {
        margin-top: 30px;
    }

    .buttons > .button {
        height: 41px;
        width: 235px;
        border-radius: 20.5px;
        background-color: #EEEEEE;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0 auto;
    }

    .button.active {
        background-color: rgba(51,153,51,0.85);
        color: white;
    }

    .footer {
        margin-top: 60px;
    }

    .terms-of-use {
        font-size: 14px;
        letter-spacing: 0.63px;
        font-weight: 500;
        line-height: 20px;
    }

    .terms-of-use > a {
        color: #339933;
        text-decoration: none;
    }

    .err-msg {
        height: 20px;
        width: 107px;
        color: #F5A623;
        font-size: 14px;
        font-weight: 500;
        letter-spacing: 1.2px;
        line-height: 20px;
        margin-top: 8px;
    }

    .resend {
        height: 20px;
        width: 100%;
        margin-top: 15px;
        margin-right: 90px;
        color: #339933;
        font-size: 14px;
        font-weight: 500;
        line-height: 20px;
        text-align: right;
    }

    .help {
        height: 20px;
        text-align: right;
        margin-right: -20px;
        margin-top: 45px;
    }

    .help > a {
        color: #9B9B9B;
        font-size: 14px;
        font-weight: 500;
        line-height: 20px;
        text-decoration: none;
    }
</style>
